import './technologies.css';
import { FaReact, FaPython, FaJava } from 'react-icons/fa';
import { SiTensorflow, SiPandas, SiFigma, SiFlutter } from 'react-icons/si';
import { FiCpu } from 'react-icons/fi';

const techStack = [
  { icon: <FaReact />, label: 'React' },
  { icon: <FaPython />, label: 'Python' },
  { icon: <FaJava />, label: 'Java' },
  { icon: <SiPandas />, label: 'Pandas' },
  { icon: <SiTensorflow />, label: 'TensorFlow' },
  { icon: <SiFigma />, label: 'Figma' },
  { icon: <FiCpu />, label: 'Gurobi' },
  { icon: <SiFlutter />, label: 'Flutter' },
];

function Technologies() {
  return (
    <section className="technologies tech-structured">
      <h2 className="techs-heading">
        <span className="highlight">Techs</span> and tools
        <span className="heading-sub">I've been recently working with</span>
      </h2>
      <p className="techs-subtitle">
        Here's my stack — from UI to AI, from code to creativity.
      </p>
      <div className="structured-grid">
        {techStack.map((tech, i) => (
          <div className="tech-box" key={i} style={{ animationDelay: `${i * 0.1}s` }}>
            <div className="icon">{tech.icon}</div>
            <span>{tech.label}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Technologies;